import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from 'ionic-angular';

import { PageHeroComponent } from './page-hero/page-hero';
import { AppQuestionnaireComponent } from './app-questionnaire/app-questionnaire';
import { ConnectionStatusComponent } from './connection-status/connection-status';
import { SharedTranslateModule } from '../app/shared-translate.module';

@NgModule({
  declarations: [PageHeroComponent, AppQuestionnaireComponent, ConnectionStatusComponent],
  imports: [CommonModule, FormsModule, IonicModule, SharedTranslateModule],
  exports: [PageHeroComponent, AppQuestionnaireComponent, ConnectionStatusComponent]
})
export class ComponentsModule { }



// WEBPACK FOOTER //
// ./src/components/components.module.ts